export default __webpack_public_path__ + "static/rowntree-hero-glow-e2082791216c2f3aa405c68d86945c14.png";